// The solution a user picks in a section is real, saved quote data (persisted server-side as
// user_quote_nav_sections.selected_lists), and the saved quote is the source of truth for restoring it
// on reload. This helper additionally MIRRORS the selection into the address bar so the link is
// shareable and self-describing: the presence of a solution_<index> query parameter tells you a
// solution is selected for that section, and its value is the picked solution's diecutting_result.uuid
// (one per part, comma-joined for a multi-part combination). It is written from the selection, never
// read back to override the saved quote — so opening a link can't silently rewrite the quote.
//
// replaceState (not pushState) is used deliberately: this only keeps the address bar in sync with the
// current selection; it does not add history entries, so the browser Back button never un-saves a
// solution. Sections are keyed by the same `index`/sort_order the rest of the flow uses.

const parameterName = (index) => `solution_${index}`;

// Mirror this section's selected solution uuid(s) into the address bar (same-origin, query only).
export const writeSelectedSolutionUuids = (index, uuids) => {
  const url = new URL(window.location.href);
  url.searchParams.set(parameterName(index), uuids.join(','));
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
};

// Remove this section's solution parameter (used when a solution is de-selected).
export const clearSelectedSolution = (index) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(parameterName(index));
  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
};
